import { render, staticRenderFns } from "./ProgramPreview.vue?vue&type=template&id=53b7bbf7&scoped=true"
import script from "./ProgramPreview.vue?vue&type=script&lang=js"
export * from "./ProgramPreview.vue?vue&type=script&lang=js"
import style0 from "./ProgramPreview.vue?vue&type=style&index=0&id=53b7bbf7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b7bbf7",
  null
  
)

export default component.exports